/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-20 19:17:58
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 00:13:08
 */
/**
 * axios 封装
 */
import axios from "axios";
import {REQUEST_TIMEOUT} from "../../config";
import {Message, Loading} from "element-ui";
import Vue from 'vue'

let loadingInstance;
var vm = new Vue();
// axios.defaults.headers.post["Content-Type"] =
//   "application/x-www-form-urlencoded";
//实例axios

let axiosConfig = {
    baseURL: "", //本地
    // baseURL: "/api",////线上需要加上的
    timeout: REQUEST_TIMEOUT,
    headers: {
        "Content-Type": "application/json",
        'Language-Code':'CN'
    },
}

// if (process.env.NODE_ENV == "production") {
axiosConfig.baseURL = '/taotan_admin_api';
//taotan_admin_api
// }

export const API = axios.create(axiosConfig);

/**
 * 添加请求拦截器
 */
API.interceptors.request.use(
    function (config) {
        if (config.headers.isLoading) loadingInstance = Loading.service();
        if (localStorage.getItem("userInfo"))
            config.headers['access-token'] = JSON.parse(
                localStorage.getItem("userInfo")
            ).accessToken;
        config.headers['app-id'] = '0';
        config.headers['channel-id'] = '0';
        config.headers['app-version'] = 'dev-1.0.0';
        config.headers['client-id'] = 't100';
        config.headers['device-scene'] = 'WEB';
        config.headers['content-type'] = 'application/json; charset=UTF-8;image/jpg'
        config.headers['device-os'] = 'Windows';
        config.headers['operate-pwd'] = sessionStorage.getItem('operationKey') ? sessionStorage.getItem('operationKey') : '';
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        Message.error("请求错误，请稍后重试！");
        return Promise.reject(error);
    }
);


/**
 * 添加响应拦截器
 */
API.interceptors.response.use(
    function (response) {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
        switch (response.data.result) {
            case -1:
                vm.$alert(response.data.message, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        localStorage.removeItem('userInfo')
                        window.location.href = "/#/login";
                    }
                });
                return response;
            case 200:
                return response;
            default:
                if (response.data.result != 200) {
                    Message.error(response.data.message);
                    if (loadingInstance) {
                        loadingInstance.close();
                        loadingInstance = null;
                    }
                }
                return response;
        }
    },
    function (error) {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
        // console.log(error)
        // 对响应错误做点什么
        if (error.response.result != undefined && error.response.result.data == -1) {
            window.location.href = "/#/login";
            // Message.error("请重新登录！");
        } else {
            Message.error(`出错了:${error.response.status} ${error.message}`);
            if (loadingInstance) {
                loadingInstance.close();
                loadingInstance = null;
            }
        }
        return Promise.reject(error);
    }
);


/**
 * 处理响应的二进字数据
 * @param {*} response
 */
